module.exports = __webpack_public_path__ + "img/eucerin-logo.45f57ae8.png";